import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const generateOfficeDoctorAttendingAccountingFormSchema = z.object({
  doctorAttending: z.object({
    id: z.string().min(1),
    label: z.string(),
    officeId: z.string().min(1),
    doctorAttendingId: z.string().min(1),
    officeName: z.string(),
  }),
  accountingMonth: z.number().min(1).max(12),
  accountingYear: z.number().min(2020).max(2050),
});

export type GenerateOfficeDoctorAttendingAccountingFormValues = z.infer<
  typeof generateOfficeDoctorAttendingAccountingFormSchema
>;

export const generateOfficeDoctorAttendingAccountingFormResolver = zodResolver(
  generateOfficeDoctorAttendingAccountingFormSchema,
);
